module.exports = '/registrations';



//////////////////
// WEBPACK FOOTER
// ./config/root-url.js
// module id = 103
// module chunks = 1